import View from './View.js';
class AddRecipeView extends View {
  _parentElement = document.querySelector('.upload');
  _window = document.querySelector('.add-recipe-window');
  _overlay = document.querySelector('.overlay');
  _btnOpenWindow = document.querySelector('.nav__btn--add-recipe');
  _btnCloseWindow = document.querySelector('.btn--close-modal');
  _message = 'Recipe was successfully uploaded :)';
  _generateMarkup() {
    return `<div class="upload__column">
          <h3 class="upload__heading">Recipe data</h3>
          <label>Title</label>
          <input value="TEST" required name="title" type="text" />
          <label>URL</label>
          <input value="TEST" required name="sourceUrl" type="text" />
          <label>Image URL</label>
          <input value="TEST" required name="image" type="text" />
          <label>Publisher</label>
          <input value="TEST" required name="publisher" type="text" />
          <label>Prep time</label>
          <input value="23" required name="cookingTime" type="number" />
          <label>Servings</label>
          <input value="23" required name="servings" type="number" />
        </div>

        <div class="upload__column">
          <h3 class="upload__heading">Ingredients</h3>
          <label>Ingredient 1</label>
          <input
            value="0.5,kg,Rice"
            type="text"
            required
            name="ingredient-1"
            placeholder="Format: 'Quantity,Unit,Description'"
          />
          <label>Ingredient 2</label>
          <input
            value="1,,Avocado"
            type="text"
            name="ingredient-2"
            placeholder="Format: 'Quantity,Unit,Description'"
          />
          <label>Ingredient 3</label>
          <input
            value=",,salt"
            type="text"
            name="ingredient-3"
            placeholder="Format: 'Quantity,Unit,Description'"
          />
          <label>Ingredient 4</label>
          <input
            type="text"
            name="ingredient-4"
            placeholder="Format: 'Quantity,Unit,Description'"
          />
          <label>Ingredient 5</label>
          <input
            type="text"
            name="ingredient-5"
            placeholder="Format: 'Quantity,Unit,Description'"
          />
          <label>Ingredient 6</label>
          <input
            type="text"
            name="ingredient-6"
            placeholder="Format: 'Quantity,Unit,Description'"
          />
        </div>

        <button class="btn upload__btn">
          <svg>
            <use href="src/img/icons.svg#icon-upload-cloud"></use>
          </svg>
          <span>Upload</span>
        </button>`;
  }
  addHandlerForm(handler) {
    this._addHandlerShowWindow();
    this._addHandlerCloseWindow();
    this._addHandlerUpload(handler);
  }
  _addHandlerShowWindow() {
    this._btnOpenWindow.addEventListener('click', this._showWindow.bind(this));
  }
  _addHandlerCloseWindow() {
    [this._overlay, this._btnCloseWindow].forEach(btn =>
      btn.addEventListener('click', this.hideWindow.bind(this))
    );
    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape') this.hideWindow();
      }.bind(this)
    );
  }
  _addHandlerUpload(handler) {
    this._parentElement.addEventListener(
      'submit',
      function (e) {
        e.preventDefault();

        const dataarr = [...new FormData(this._parentElement)];
        const data = Object.fromEntries(dataarr);
        // console.log(this._generateRecipe(data));

        handler(data);
        // this._hideWindow();
      }.bind(this)
    );
  }
  _showWindow() {
    this.render('form');
    this._window.querySelector('input').focus();
    this._window.classList.remove('hidden');
    this._overlay.classList.remove('hidden');
  }
  hideWindow() {
    this._window.classList.add('hidden');
    this._overlay.classList.add('hidden');
  }
}
export default new AddRecipeView();
